import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { updateContract } from '../data-provider';
import type { Contract, ContractApi } from '../models';
import { CACHE_KEYS } from '../types';

export const useUpdateContract = ({ onSuccess }: { onSuccess?: (contract: ContractApi) => void } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (contract: Contract) => updateContract(contract),
    onError: () => {
      showNotification({
        message: 'An error has occurred. Please, try again',
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSuccess: (contract) => {
      queryClient.invalidateQueries({ queryKey: CACHE_KEYS.all });
      showNotification({
        message: 'Successfully updated the contract',
        type: NOTIFICATION_TYPES.SUCCESS,
      });
      onSuccess?.(contract);
    },
  });
};
